import Login from  './Login.vue';
import Lock from './Lock.vue';

export default{
	Login,
	Lock
}